// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"64":"354b9d20","142":"e4a85186","233":"08740e58"}[chunkId] + ".css";
};